module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAATCAYAAABPwleqAAABB0lEQVQ4jZ2TPUpDQRRGzzwRAiqkEdfgD4iFbsDOJSi4AldgmVpbRRsXYO8CBE2pIokp7C2ECBYSjeFY6JCXyYu8vAO3+w535s7coJKwBOwBm8Ai8A7cA5fA00hSzdeh+uFkTtV6zOfFm3+kPC/qfF4+KylGmipBXQFa6cVLsI96PmXXyENQH4G1Cp37GVCvIAIMMuCtohwyoFlR7gR1GWhXkHfjO59MOelbkx92VVJ8VudSGbWhdidI3+qFWov54PhWzQDrwBbDrboDrtNgkbwAHAA1YBYYAF9Ah9+1HJIcG3VV/VRf1ZbaVvt/Rx7JFnWObAM7QA84BrpjiYLOsY5yw9ooyvwARWkTQxqao8YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/trainclass-helper.png
// module id = wT8Z
// module chunks = 1